// components/CeldaProducto.tsx
import { Box, Chip, Typography } from "@mui/material";
import { IconMessage } from "@tabler/icons-react";
import { SharedTextoRecortado } from "shared/table";
import { requiereComentario } from "../utils/productoSeleccionado.utils";

interface CeldaProductoProps {
    nombre: string;
    clave?: string;
    tipoProducto?: string;
    unidadMedida?: string;
    comentarios?: string;
    ocultarComentario?: boolean;
}

export const CeldaProducto = ({
    nombre,
    clave,
    tipoProducto,
    comentarios = "",
    ocultarComentario = false,
}: CeldaProductoProps): JSX.Element => {
    const secundario = [clave, tipoProducto].filter(Boolean).join(" · ");
    const falta = requiereComentario(clave) && !comentarios.trim();

    return (
        <Box sx={{ minWidth: 0, lineHeight: 1.2 }}>
            <SharedTextoRecortado texto={nombre} />
            {secundario && (
                <Typography variant="caption" color="text.secondary" component="div" noWrap title={secundario}>
                    {secundario}
                    {falta && (
                        <Chip
                            label="Falta comentario"
                            size="small"
                            color="error"
                            variant="outlined"
                            sx={{ ml: 1, height: 18, fontSize: "0.65rem" }}
                        />
                    )}
                </Typography>
            )}
            {comentarios && !ocultarComentario && (
                <Typography
                    variant="caption"
                    component="div"
                    title={comentarios}
                    sx={{
                        mt: 0.25,
                        display: "flex",
                        gap: 0.5,
                        color: "#4a6fa5",
                        fontStyle: "italic",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    }}
                >
                    <IconMessage size={14} stroke={2} style={{ flexShrink: 0, marginTop: 2 }} />
                    {comentarios}
                </Typography>
            )}
        </Box>
    );
};